import {OverlayModule} from '@angular/cdk/overlay';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatTooltipModule} from '@angular/material/tooltip';
import {HelpRecordLatencyModule} from '../content/help-record-latency/help-record-latency.module';
import {HelpSelectMicrophoneModule} from '../content/help-select-microphone/help-select-microphone.module';
import {HelpCompressorModule} from '../content/help-compressor/help-compressor.module';
import {HelpGainModule} from '../content/help-gain/help-gain.module';
import {HelpTooltipComponent} from './help-tooltip.component';

@NgModule({
  declarations: [HelpTooltipComponent],
  exports: [HelpTooltipComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MatButtonModule,
    OverlayModule,

    HelpSelectMicrophoneModule,
    HelpGainModule,
    HelpCompressorModule,
    HelpRecordLatencyModule
  ]
})
export class SptHelpTooltipModule {}
